import {sharedCampaigns} from '@cl/shared';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTOptimizationNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {
  OptimizeAcrossValue,
  OptimizeByValue,
} from 'common/src/modules/optimization/optimization.types';
import {DEFAULT_DROP_CONDITIONS} from 'common/src/modules/optimization/optimization.consts';
import {CLStore} from 'common/src/redux/store';

function createDefaultOptimizationCard(): DTOptimizationNode {
  return {
    id: NO_NODE_ID,
    name: 'Optimization Card',
    description: '',
    type: NodeType.GENERAL_OPTIMIZATION,
    x: 0,
    y: 0,
    outputs: [
      {id: 1, name: 'Output 1', type: OutputType.Regular, nodeId: NO_NODE_ID},
      {id: 2, name: 'Output 2', type: OutputType.Regular, nodeId: NO_NODE_ID},
    ],
    inputs: [],
    configuration: {
      optimizeBy: OptimizeByValue.Clicks,
      optimizeGroup: OptimizeAcrossValue.Campaign,
      areAllAttributionSignalsSelected: true,
      areAllConversionTypesSelected: true,
      attributionSignalIds: [],
      conversionTypes: [],
      entitiesToShowGoal: 1,
      postOptimizationServingCoefficient: 1,
      dropConditions: DEFAULT_DROP_CONDITIONS,
    },
    variationsCount: 2,
  };
}

/**
 * Gets an existing optimization card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0/undefined for a new card
 * @returns The optimization card (existing or new)
 */
async function getOrCreateOptimizationCard(
  cardId: number | undefined,
  _store: CLStore,
): Promise<DTOptimizationNode> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.GENERAL_OPTIMIZATION) {
      throw new Error(`Card with id ${resolvedCardId} is not an optimization card`);
    }

    return existingCard as DTOptimizationNode;
  }

  return createDefaultOptimizationCard();
}

export default getOrCreateOptimizationCard;
export {createDefaultOptimizationCard};
